/* eslint-disable import/prefer-default-export */
export const timeout = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
